import { useMutation, useQuery, useQueries, useQueryClient } from '@tanstack/react-query';
import {
  createInquiry,
  getInquiryList,
  getAdminInquiryList,
  updateInquiry,
} from '@entities/inquiry/api/inquiry';

export function useCreateInquiryMutation(options = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => createInquiry(payload),

    onSuccess: (data, variables, context) => {
      // 문의 목록 캐시 무효화 (목록 페이지가 있다면)
      queryClient.invalidateQueries(['inquiryList']);

      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },

    onError: (error) => {
      if (options.onError) {
        options.onError(error);
      }
    },

    ...options,
  });
}

export function useInquiryListQuery() {
  return useQuery({
    queryKey: ['inquiryList'],
    queryFn: getInquiryList,
  });
}

export function useAdminInquiryListQuery(params = {}, options = {}) {
  return useQuery({
    queryKey: ['adminInquiryList', params], // 검색조건 기반 캐시
    queryFn: () => getAdminInquiryList(params),
    keepPreviousData: true, // 페이지 변경 시 UX 안정
    staleTime: 1000 * 30, // 30초 캐싱 (필요 시 조정)
    ...options,
  });
}

export function useUpdateInquiryMutation(options = {}) {
  return useMutation({
    mutationFn: ({ idx, payload }) => updateInquiry(idx, payload),

    onSuccess: (data, variables, context) => {
      if (options.onSuccess) {
        options.onSuccess(data);
      }
    },

    onError: (error) => {
      if (options.onError) {
        options.onError(error);
      }
    },

    ...options,
  });
}
